import React from 'react';

import styles from './style.css';
import { Icon } from '../Icon';
import ChevronUpIcon from '@/icons/chevron-up.svg';
import ChevronDownIcon from '@/icons/chevron-down.svg';

export function DropdownSelect({ selectedLabel, placeholder, isOpen, onToggle, className = '' }) {
    const hasValue = !!selectedLabel;

    return (
        <button
            type="button"
            className={[styles.selectButton, className].filter(Boolean).join(' ')}
            aria-haspopup="listbox"
            aria-expanded={isOpen}
            onClick={onToggle}
        >
            <span className={hasValue ? undefined : styles.placeholder}>
                {hasValue ? selectedLabel : placeholder}
            </span>

            <span aria-hidden="true">
                {isOpen ? <Icon icon={ChevronUpIcon} /> : <Icon icon={ChevronDownIcon} />}
            </span>
        </button>
    );
}
